export default __webpack_public_path__ + "ef24ace6c4590e061ca2d8b0201315b1.svg";